<template>
	<div>
		<b-modal :id="id"
				 modal-class="modal-img-in-top"
				 hide-footer
				 hide-header
				 size="md"
				 @hidden="chat_id = ''"
		>
			<div class="wrap-img">
				<img src="../assets/images/ducks/send.png" alt="">
			</div>
			<div class="modal-content">
				<h2 class="title">{{title}}</h2>
				<p class="text-center">When should messages in the chat room expire?</p>
				<div class="wrap-radio-btn">
					<div v-for="item in expiryDateOptions" :key="item.id" class="form-check radio-btn">
						<input class="form-check-input" type="radio" name="chatRadios"
							   :id="`${item.title}`"
							   :value="`${item.value}`" v-model="checkedExpireDate">
						<label class="form-check-label" :for="`${item.title}`">
							{{item.title}}
						</label>
					</div>
				</div>
				<div class="">
					<button @click.prevent="newChat()" class="btn-new-chat">Create</button>
				</div>
			</div>
		</b-modal>
		<Flash ref="show"/>
	</div>
</template>

<script>
	import Flash from "../components/Flash";
	import generate_key from "../mixins/generate_key";
	import {api} from "../mixins/axios";

	export default {
		name: 'Chat',
		components: {
			Flash
		},
		mixins:[generate_key],
		props: {
			title: String,
			api_title: String,
			id: String,
			text_placeholder: String,
			phone: String,
			top_img: String,
		},
		data() {
			return {
				checkedExpireDate: 1440,
				expiryDateOptions: [
					{
						id: 1,
						title: "10 minutes",
						value: 10,
					},
					{
						id: 2,
						title: "1 day",
						value: 1440,
					},
					{
						id: 3,
						title: "1 month",
						value: 43200,
					},
				],
				chat_id: "",
				host: "",
				encryptKey: "",
			}
		},
		methods: {
			async newChat(){
				try {
					let data = {
						attrs: ["pid"],
						expire_msgs: this.checkedExpireDate
					}

					this.encryptKey = this.generateEncryptKey(32)
					const response = await api.post(`/chats/new_chatroom`, data);

					if (response.data.status == 'ok') {
						this.$bvModal.hide("modal-show-chat")
						this.chat_id = response.data.room.pid
						location.href = `/chat/${this.chat_id}#${this.encryptKey}`
					}
				} catch (e) {
					console.log(e)
				}
			}
		},
		mounted() {
			this.host = location.origin
		}
	}
</script>

<style scoped lang="scss">
	.btn-new-chat{
		background: #FF7A00;
		border-radius: 6px;
		font-weight: 600;
		font-size: 16px;
		line-height: 28px;
		text-align: center;
		letter-spacing: -0.02em;
		color: #FFFFFF;
		width: 100%;
		padding: 13px 15px;
		outline: none;
		box-shadow: unset;
		border: none;

		&:hover {
			background: #21405B;
		}
		&:disabled{
			background: #ff962e;
		}
	}
	.modal-content {
		padding: 20px 25px 25px 25px;
		@include media-breakpoint-up(sm) {
			padding: 40px 50px 50px 50px;
		}
		.title {
			font-weight: bold;
			font-size: 30px;
			line-height: 37px;
			letter-spacing: -0.02em;
			color: #323232;
			margin-bottom: 20px;
			text-align: center;
		}
	}
	.modal-img-in-top{
		.wrap-img {
			padding-top: 26px;
			padding-bottom: 26px;
			background: #21405B;
			text-align: center;
			min-height: 169px;
		}
	}
	::v-deep .modal-body {
		padding: 0;
	}
	.wrap-radio-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 21px;
		gap: 5px;
		@include media-breakpoint-up(sm) {
			gap: 15px;
		}
		@include media-breakpoint-up(lg) {
			gap: 35px;
			margin-bottom: 40px;
		}
		.radio-btn {
			display: flex;
			align-items: center;
			margin-bottom: 0px;
			padding-left: 0;

			.form-check-label {
				padding: 0 6px;
				align-self: center;
				cursor: pointer;
				height: 16px;
				font-size: 12px;
				letter-spacing: -0.02em;
				color: #000;
				@include media-breakpoint-up(lg) {
					font-size: 16px;
					height: 22px;
					padding: 0 10px;
				}
			}
		}

		.form-check-input {
			-webkit-appearance: none;
			width: 16px;
			height: 16px;
			border: 1px solid #ccc;
			border-radius: 50%;
			outline: none;
			cursor: pointer;
			margin-left: 0;
			margin-top: 0;

			&:checked {
				background: #fff;
				border: 1px solid #FF7A00;
				outline: none;
				box-shadow: none;

				&:before {
					background: #FF7A00;
				}
			}

			&:before {
				content: '';
				display: block;
				width: 60%;
				height: 60%;
				margin: 20% auto;
				border-radius: 50%;
			}

			@include media-breakpoint-up(sm) {
				width: 22px;
				height: 22px;
			}
		}
	}

	.copy-message-url {
		@include btn-orange;
		width: 100%;
		position: relative;

		@include media-breakpoint-up(sm) {
			position: absolute;
			right: 3px;
			top: 3px;
			z-index: 10;
			width: auto;
		}
	}
	.url-input {
		background: #FFFFFF;
		border: 1px solid #E5E5E5;
		border-radius: 2px 6px 6px 2px;
		font-weight: 600;
		font-size: 16px;
		line-height: 20px;
		letter-spacing: -0.02em;
		color: #6C6C74;
		padding-top: 17px;
		padding-bottom: 17px;
		margin-bottom: 15px;
		outline: none;
		width: 100%;
		box-shadow: none;
	}
</style>
